import { GridAggregationModel, GridColumnVisibilityModel, GridFilterModel } from '@mui/x-data-grid-premium'

export const defaultColumnOrder: string[] = [
  'name',
  'commentCount',
  'contractId',
  'dba',
  'invoiceStatus',
  'billingStatus',
  'type',
  'invoiceOption',
  'agreementOption',
  'startDate',
  'endDate',
  'organizations',
  'dealStatus',
  'reasonChurn',
  'lastDateOfService',
  'churnNote',
  'contractedBy',
  'id',
  'stage',
  'lastModified',
  'timeCompleted',
  'amId',
  'billingContact',
  'primaryContact',
  'implementationFee',
  'total',
]
export const ncoAggregationModel: GridAggregationModel = {
  totalContractAmount: 'sum',
  monthlyContractAmount: 'sum',
  // overallProgress: 'sum',
  // activeCount: 'sum',
  searchSpend: 'sum',
  metaSpend: 'sum',
  bingSpend: 'sum',
  spotifySpend: 'sum',
  linkedinSpend: 'sum',
  snapchatSpend: 'sum',
  tiktokSpend: 'sum',
  progDisplaySpend: 'sum',
  progAudioSpend: 'sum',
  displaySpend: 'sum',
  dmsOpts: 'sum',
  seoOpts: 'sum',
  totalQualifiedOpts: 'sum',
  opts: 'sum',
  totalMediaSpend: 'sum',
  monthlyMediaSpend: 'sum',
  msaMonthlyTotal: 'sum',
  ioMonthlyTotal: 'sum',
  csaMonthlyTotal: 'sum',
  totalMonthlyFee: 'sum',
  implementationFee: 'sum',
  grossProfit: 'sum',
  total: 'sum',
}

// View state configuration
const allFields = [
  'name',
  'orgNameReference',
  'dateRange',
  'activeCount',
  'billingContact',
  'searchSpend',
  'metaSpend',
  'bingSpend',
  'spotifySpend',
  'linkedinSpend',
  'snapchatSpend',
  'tiktokSpend',
  'progDisplaySpend',
  'progAudioSpend',
  'displaySpend',
  'tier1Spend',
  'tier2Spend',
  'tier3Spend',
  'overallProgress',
  'amProgress',
  'seoProgress',
  'dmsProgress',
  'dmsOpts',
  'seoOpts',
  'totalQualifiedOpts',
  'opts',
  'seoStatus',
  'vertical',
  'masterStatus',
  'products',
  'seoGmb',
  'type',
  'timeCompleted',
  'seoTier',
  'dependenciesDueDate',
  'estLaunchDate',
  'dateLaunched',
  'startDate',
  'endDate',
  'contractedBy',
  'totalMediaSpend',
  'lastModified',
  'status',
  'implementationFee',
  'total',
  'team_details',
  'website',
  '__tree_data_group__',
  'qualifyingTier',
  'monthlySeo',
  'optsProgress',
  'slaDays',
  'owner',
  'creatives',
  'monthlyMediaSpend',
  'totalContractAmount',
  'monthlyContractAmount',
  'msaMonthlyTotal',
  'ioMonthlyTotal',
  'csaMonthlyTotal',
  'totalMonthlyFee',
  'month',
  'isGoogleDisplay',
  'isGoogleSearch',
  'isMetaAdvertising',
  'isMicrosoftAdvertising',
  'isSimplifi',
  'isSnapchat',
  'isSpotify',
  'isTikTok',
  'isYoutube',
  'isSeo1',
  'isSeo2',
  'isSeo3',
  'isSeo4',
]

const baseVisibility: Record<string, boolean> = {}
allFields.forEach(fieldName => {
  baseVisibility[fieldName] = false
})

const defaultStatusFilter = {
  id: 'default-nco-status',
  field: 'onboardingStatus',
  operator: 'notAnyOf',
  value: ['Launched', 'Bypass'],
}

export const filter_model_nco: GridFilterModel = { items: [defaultStatusFilter], quickFilterValues: [] }

export const seoViewState = {
  ...baseVisibility,
  name: true,
  activeCount: true,
  overallProgress: true,
  seoProgress: true,
  seoOpts: true,
  totalQualifiedOpts: true,
  opts: true,
  seoStatus: true,
  masterStatus: true,
  seoGmb: true,
  seoTier: true,
  team_details: true,
}

export const projectManagerViewState: GridColumnVisibilityModel = {
  ...baseVisibility,
  name: true,
  isSeo1: false,
  isSeo2: false,
  isSeo3: false,
  isSeo4: false,
  type: false,
  timeCompleted: false,
  dependenciesDueDate: false,
  slaDays: false,
  estLaunchDate: false,
  dateLaunched: false,
  startDate: false,
  endDate: false,
  contractedBy: false,
  strategy: false,
  status: false,
  id: false,
  stage: false,
  lastModified: false,
  products: false,
  owner: false,
  implementationFee: false,
  total: false,
  vertical: false,
  creatives: false,
  creativeLead: false,
}
export const EDITABLE_FIELDS = ['onboardingStatus', 'dependenciesDueDate', 'slaDays', 'dateLaunched']
